import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { TopWPSAInitialState } from "../../interface";
import { getTopWPSAData } from "src/api/bi";
import { resetStore } from "src/store/actions";

export const fetchTopWPSAData = createAsyncThunk(
  "dashboard/fetchTopWPSAData",
  ({
    department,
    storeFinId,
    page,
    _showLoader
  }: {
    department: string;
    storeFinId: string;
    page: number;
    _showLoader: boolean;
  }) => getTopWPSAData({ department, storeFinId, page })
);

const initialState: TopWPSAInitialState = {
  topWPSAData: [],
  page: 0,
  status: "idle",
  error: null,
  hasMore: true,
  showLoader: false
};

const topWPSASlice = createSlice({
  name: "topWPSA",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchTopWPSAData.pending, (state, action) => {
        state.status = "pending";
        state.showLoader = action.meta.arg._showLoader;
      })
      .addCase(fetchTopWPSAData.fulfilled, (state, action) => {
        const { data } = action.payload;
        const page = action.meta.arg.page;
        state.status = "idle";
        state.showLoader = false;
        state.hasMore = true;
        state.page = page;

        if (page === 0) {
          state.topWPSAData = data;
        } else {
          state.topWPSAData = state.topWPSAData.concat(data);
        }

        if (!data.length) {
          state.hasMore = false;
        }
      })
      .addCase(fetchTopWPSAData.rejected, (state) => {
        state.status = "error";
        state.topWPSAData = [];
        state.showLoader = false;
      });
  }
});

export const selectTopWPSAData = ({
  topWPSA
}: {
  topWPSA: TopWPSAInitialState;
}) => topWPSA.topWPSAData;

export const selectTopWpsaApiStatus = ({
  topWPSA
}: {
  topWPSA: TopWPSAInitialState;
}) => topWPSA.status;

export const selectPage = ({ topWPSA }: { topWPSA: TopWPSAInitialState }) =>
  topWPSA.page;

export const selectHasMore = ({ topWPSA }: { topWPSA: TopWPSAInitialState }) =>
  topWPSA.hasMore;

export default topWPSASlice.reducer;
